const API_BASE_URL = "https://v2.api.noroff.dev";
export const API_PRODUCTS = `${API_BASE_URL}/online-shop`;
